import styled from '@emotion/styled';

export const StyledProgressBar = styled.div`
  display: flex;
  align-items: center;
  height: 12px;

  progress {
    -webkit-appearance: none;
    height: 8px;
    flex: 1;
    border: none;
    margin-right: var(--gutter-little);
  }

  progress[value]::-webkit-progress-bar {
    background-color: var(--color-core-grey-light);
    border-radius: 2px;
  }

  progress[value]::-webkit-progress-value {
    height: 8px;
    border-radius: 2px;
    background-color: var(--color-core-primary);
  }
`;
